export default __webpack_public_path__ + "static/media/greenhouse-message.fa5370a4.png";